module.exports = __webpack_public_path__ + "img/kaltura.png";